<template>

    <div class="layout__container">

        <div class="layout__width-90 layout__padding-clear">

        <span class="text__colour-teal layout__position-left layout__padding-10-4 layout__width-100 text__align-center">
            <h3 class="layout__position-center">Create Product Codes</h3><h4 class="layout__position-center">(Enter the record details and click to Save Changes or Cancel)</h4>
        </span>

            <el-form :model="product" ref="product" :rules="rules" class="layout__position-left layout__width-100">

                <div class="component__forms-4">
                    <el-form-item prop="productRef" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Order Code<span class="text__colour-red">*</span>
                        </div>
                        <el-input v-model="product.productRef" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                    <!--<el-form-item prop="priceCode" class="component__forms__fields">-->
                    <!--<div class="component__forms__fields__labels">Price Code</div>-->
                    <!--<el-input v-model="product.priceCode" class="layout__position-left">-->
                    <!--</el-input>-->
                    <!--</el-form-item>-->


                    <el-form-item prop="priceCode" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Price Code</div>
                        <el-select v-model="product.priceCode" placeholder="Select price code" clearable="true"
                                   filterable>
                            <el-option
                                    v-for="priceCode in priceCodes"
                                    :key="priceCode.code"
                                    :label="priceCode.code"
                                    :value="priceCode.code">
                            </el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item prop="name" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Name<span class="text__colour-red">*</span></div>
                        <el-input v-model="product.name" class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>

                <div class="component__forms-4">
                    <el-form-item prop="status" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Status</div>
                        <el-select v-model="product.status" placeholder="Select Status" clearable="true">
                            <el-option
                                    v-for="status in ravensworth.activeStatusWithHold.options"
                                    :key="status.id"
                                    :label="status.text"
                                    :value="status.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item prop="type" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Type</div>
                        <el-select v-model="product.type" placeholder="Select Types" clearable="true">
                            <el-option
                                    v-for="type in ravensworth.priceCodeType.options"
                                    :key="type.id"
                                    :label="type.text"
                                    :value="type.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="press" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Press</div>
                        <el-select v-model="product.press" placeholder="Select Press" clearable="true">
                            <el-option
                                    v-for="press in ravensworth.press.options"
                                    :key="press.id"
                                    :label="press.text"
                                    :value="press.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="isoSize" class="component__forms__fields">
                        <div class="component__forms__fields__labels">ISO Size</div>
                        <el-select v-model="product.isoSize" placeholder="Select ISO Size" clearable="true">
                            <el-option
                                    v-for="iso in ravensworth.isoSize.options"
                                    :key="iso.id"
                                    :label="iso.text"
                                    :value="iso.value">
                            </el-option>
                        </el-select>
                    </el-form-item>

                </div>
                <div class="component__forms-4">
                    <el-form-item prop="style" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Style</div>
                        <p v-if="this.product.style">{{this.product.style}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                    <el-form-item prop="paperWeight" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Paper Weight</div>
                        <p v-if="this.product.paperWeight">{{this.product.paperWeight}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                    <el-form-item prop="paperType" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Paper Type</div>
                        <p v-if="this.product.paperType">{{this.product.paperType}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                    <el-form-item prop="finishing" class="component__forms__fields">
                        <div class="component__forms__fields__labels">Finishing</div>
                        <p v-if="this.product.finishing">{{this.product.finishing}}</p>
                        <p v-else>-</p>
                        <br>
                    </el-form-item>
                </div>
                <div class="component__forms-4 layout__position-left">
                    <el-form-item prop="finishingInstructions" class="component__forms__fields">
                        <span class="text_colour-909399 component__forms__fields__labels">Finishing Instructions</span>
                        <el-input type="textarea" :rows="4" v-model="product.finishingInstructions"
                                  class="layout__position-left">
                        </el-input>
                    </el-form-item>
                    <el-form-item prop="specialInstructions" class="component__forms__fields">
                        <span class="text_colour-909399 component__forms__fields__labels">Special Instructions</span>
                        <el-input type="textarea" :rows="4" v-model="product.specialInstructions"
                                  class="layout__position-left">
                        </el-input>
                    </el-form-item>
                </div>


            </el-form>

            <div class="layout__position-right layout__width-100">
                <el-button class="button-red button__base__admin layout__position-right">Delete</el-button>
                <el-button class="button-teal button__base__admin layout__position-right layout__margin__right-20px"
                           v-on:click="cancelChanges()">Cancel Changes
                </el-button>
                <el-button class="button-red button__base__admin layout__position-right layout__margin__right-20px"
                           v-on:click="updateProduct('product')">Save Changes
                </el-button>
                <div id="message"></div>
            </div>

        </div>
    </div>

</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {csvDownloadHelper} from '@/mixins/CsvDownloadHelper.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import {backing} from '@/mixins/Backing.js';

    export default {
        name: "createCustomers",
        mixins: [axios, csvDownloadHelper, dataFormatter, backing],
        data() {
            return {
                product: {
                    productRef: '',
                    priceCode: '',
                    name: '',
                    finishingInstructions: '',
                    specialInstructions: '',
                    status: 'ACTIVE',
                    type: '',
                    press: '',
                    style: '',
                    isoSize: '',
                    paperWeight: '',
                    paperType: '',
                    finishing: '',
                },
                types: [],
                statuses: [],
                presses: [],
                isos: [],
                finishings: [],
                priceCodes: [],
                rules: {
                    productRef: [{
                        required: true,
                        message: 'order code required',
                        trigger: 'blur'
                    }],
                    name: [{
                        required: true,
                        message: 'name required',
                        trigger: 'blur'
                    }],
                }
            }
        },
        created() {

            this.isUserAuthorised();
            const getPriceCodes = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/Search/productPriceLookup?`
            Axios.get(getPriceCodes, this.returnHeaderUsingToken())
                .then(response => {
                    console.log(response.data)
                    this.priceCodes = response.data.value
                })
        },
        methods: {
            updateProduct(product) {
                this.$refs[product].validate((valid) => {
                    if (valid) {
                        console.log('done post')

                        const createProduct = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Products/Create`

                        console.log(this.product)

                        const loading = this.$loading({
                            lock: true,
                            text: 'Saving Changes...',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });

                        Axios.post(createProduct, this.product, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response)
                                this.product = response.data.result
                                document.getElementById("message").innerText = "Product Code Successfully Created"
                                document.getElementById("message").classList.add('component__message-base', 'component__message-success', 'layout__display-block')
                                // this.priceCodes = response.data.value

                                loading.close()
                            })
                            .catch(error => {
                                document.getElementById("message").innerText = "There was a problem creating the product code - please try again"
                                document.getElementById("message").classList.add('component__message-base', 'component__message-fail', 'layout__display-block')
                                loading.close()
                            })


                    } else {
                        return false;
                    }
                })
            },
            cancelChanges() {
                this.product =
                    {
                        productRef: '',
                        priceCode: '',
                        name: '',
                        finishingInstructions: '',
                        specialInstructions: '',
                        status: 'active',
                        type: '',
                        press: '',
                        style: '',
                        isoSize: '',
                        paperWeight: '',
                        paperType: '',
                        finishing: '',

                    }
            }
        }
    };
</script>